const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

if (!API_BASE_URL) {
  console.error("Connection not configured");
}

export async function sendContactEmail(contactData) {
  try {
    const response = await fetch(`${API_BASE_URL}/contact`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(contactData),
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to send contact email");
    }

    return data;
  } catch (error) {
    console.error("Error sending contact email:", error);
    throw error;
  }
}
